import { useEffect } from "react";
import FullScreenPanel from "app/ui/FullScreenPanel";
import cn from "app/util/classnames";

const CREDITS = [
  {
    role: "Project Leads",
    name: "Alex Rosenthal, Singfisher Games, Dennis Carr",
  },
  { role: "Editor", name: "Paolo Pasco" },
  {
    role: "Front-end Design and Development",
    name: "Dennis Carr, Singfisher Games",
  },
  { role: "Back-end Development", name: "Nick Coyne, Kara Todd" },
  {
    role: "Sound Design",
    name: "Julia Henderson",
  },
  { role: "Title Art", name: "Natalia Ammon" },
  { role: "Quality Assurance", name: "Abi Dandrea" },
  { role: "Original Game Concept", name: "Non Ishida, Tetsuya Nishio" },
];

interface CreditsProps {
  onClose: () => void;
}

export default function Credits(props: CreditsProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FullScreenPanel
      heading="Credits"
      headingClassName="px-9 py-3"
      onClose={props.onClose}
      panelClassName="min-h-165"
    >
      <ul className="flex flex-col gap-5 pb-3">
        {CREDITS.map((credit) => (
          <CreditEntry role={credit.role} name={credit.name} />
        ))}
      </ul>
    </FullScreenPanel>
  );
}

interface CreditEntryProps {
  role: string;
  name: string;
}

function CreditEntry({ role, name }: CreditEntryProps) {
  return (
    <li className={cn("flex flex-col items-center")}>
      <p className="text-sm">{role}</p>
      <p className="text-center font-bold">{name}</p>
    </li>
  );
}
